import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import { HeroBackground } from "../components/HeroBackground";
import { useEffect } from "react";
import Button from "../components/Button";
import "./LoginPage.css";
import Countdown from "react-countdown";
import CountdownRenderer from "../components/CountdownRenderer";

const LoginPage = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/application" replace />;
  }

  return (
    <>
      <div className="hero">
        <HeroBackground />

        <h1 className="hero-text">Portal</h1>
        <div className="buttons-container">
          <Button
            className="dq-login-button"
            onClick={() =>
              loginWithRedirect({
                appState: { returnTo: "/events/duquantum-2026" },
              })
            }
          >
            DuQuantum Attendee
          </Button>
        </div>
        <Countdown
          date={new Date("2026-10-24T09:00:00-04:00")}
          renderer={({ days, hours, minutes, seconds }) => (
            <CountdownRenderer
              days={days}
              hours={hours}
              minutes={minutes}
              seconds={seconds}
              deadlineType="DuQuantum 2026 begins"
            />
          )}
        />
      </div>
    </>
  );
};

export default LoginPage;
